import $ from "jquery";

const glossaryScroll = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        $(document).ready(function () {
            $('a[href^="#glossary-"]').on('click', function (e) {
                e.preventDefault();

                const targetId = $(this).attr('href');
                const $target = $(targetId);

                if ($target.length) {
                    const isMobile = window.innerWidth <= 600;
                    const offset = isMobile ? -160 : -200;
                    const targetPosition = $target.offset().top + offset;

                    $('html, body').animate({
                        scrollTop: targetPosition
                    }, 500);
                }
            });
        });
    };

    init();
};

try {
    glossaryScroll();
} catch (error) {
    console.error('glossaryScroll', error);
}
